import { Directive, HostBinding, Input } from '@angular/core';
import { UserAvailability } from 'src/app/core/enums/user/user-availability.enum';

@Directive({
    selector: '[appUserAvailabilityIcon]',
    standalone: false
})
export class UserAvailabilityIconDirective {

  @Input() set availability(availability: UserAvailability) {
    this.iconType = this.getIconType(availability)
    this.color = this.getClass(availability)
  }

  @HostBinding('innerHTML') iconType = '';
  @HostBinding('style.color') color = ''


  constructor() {
  }

  private getIconType(availability: UserAvailability) {
    switch (availability) {
      case UserAvailability.Available: return 'check_circle'
      case UserAvailability.Unavailable: return 'cancel'
      case UserAvailability.Interdict: return 'pause_circle'
      default: return ''
    }
  }

  private getClass(availability: UserAvailability) {
    switch (availability) {
      case UserAvailability.Available: return 'green'
      case UserAvailability.Unavailable: return 'red'
      case UserAvailability.Interdict: return '#5a585a'
    }
  }

}
